export * as Api from './api';

export enum InitialTargetShareOption {
  InitialTargetShares = 'initialTargetShares',
  InitialTargetInvestment = 'initialTargetInvestment',
  InitialTargetAllocationPercent = 'initialTargetAllocationPercent',
  InitialTargetInvestmentAndShares = 'initialTargetInvestmentAndShares',
}

export interface TrancheData {
  _id: string;
  tranche: string;
  existingDraftAllocation: boolean;
  trancheAllocations: number;
  trancheHoldings: number;
  trancheSubscriptions: {
    count: number;
    containsSubscriptionsAfterInvestmentDate: boolean;
  };
  trancheCloseDate: string;
  totalTrancheCapital: number;
  totalTrancheInvestmentCapital: number;
  remainingTrancheInvestmentCapital: number;
  remainingTrancheInvestmentCapitalPercent: number;
  leastDiversifiedTrancheInvestor: number;
  minimumInvestorPortfolioSize: number;
  minimumInvestorPortfolioSizeFixed: boolean;
  maximumSingleCompanyAllocation: number;
  initialTargetShares: number;
  defaultTransactionFeePercent: number;
  defaultTransactionFeeVatPercent: number;
  lowestInvestmentCapitalInSelection: number;
  lowestInvestmentCapitalOfLowestDiversifiedInvestors: number;
  fixedTargetShares?: number;
}

export interface AutoAllocatingTranche extends TrancheData {
  order: number;
  isRemoved: boolean;
  initialTargetShares: number;
  finalDeal: boolean;
}
